<template>
  <div class="lszj_wrap">
    <div class="lszj_list">
      <div
        class="lszj_item"
        v-for="(item, index) in lszjList.rows"
        :key="index"
      >
        <div class="stock">{{ item.stockName }}/{{ item.stockCode }}</div>

        <div class="deal_box">
          <div class="left">
            <div class="box">
              <div>{{ item.buyTime }}</div>
              <div>买入</div>
              <div>买入价格：{{ COMMON.formatToFixed(item.buyPrice) }}</div>
              <!-- <div>止盈：{{ COMMON.formatToFixed(item.stopProfitPrice) }}</div> -->
            </div>

            <div class="box sell_box">
              <div>{{ item.sellTime }}</div>
              <div>卖出</div>
              <div>卖出价格：{{ COMMON.formatToFixed(item.sellPrice) }}</div>
              <!-- <div>止损：{{ COMMON.formatToFixed(item.stopLossPrice) }}</div> -->
            </div>
          </div>

          <div class="text zyzs">
            {{
              item.strategyStatus == 1
                ? "止盈"
                : item.strategyStatus == 2
                ? "止损"
                : ""
            }}
          </div>

          <div class="text cycle">持股周期：{{ item.holdDay }}天</div>

          <div class="text profit">
            实现利润：
            <span :class="{ sp: item.yieldRate < 0 }">
              {{ item.yieldRate >= 0 ? "+" : ""
              }}{{ COMMON.formatToFixed(item.yieldRate) }}%
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination_box">
      <el-pagination
        size="small"
        background
        v-model:current-page="pageNum"
        v-model:page-size="pageSize"
        layout="prev, pager, next"
        :total="lszjList.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoList: {},
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 4,
      lszjList: {},
    };
  },
  created() {
    this.getHistoryList(); // 获取 历史战绩 list
  },
  mounted() {},
  methods: {
    // 获取 历史战绩 list
    getHistoryList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        strategyId: this.infoList.id,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/history-record", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data;
          // console.log(datas);

          if (datas) {
            this.lszjList = datas;
          }
        }
      );
    },

    // 分页 页码切换
    handleCurrentChange() {
      this.getHistoryList(); // 获取 历史战绩 list

      this.$emit("smoothFixedHeight"); // 父页面 平滑 滚到到顶部
    },
  },
};
</script>

<style lang="less" scoped>
.lszj_wrap {
  .lszj_list {
    min-height: 500px;
    font-size: 14px;

    .lszj_item {
      margin-top: 48px;

      .deal_box {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          .box {
            display: flex;

            div {
              margin-left: 50px;

              &:first-child {
                margin-left: 0;
              }
            }

            &.sell_box {
              margin-top: 24px;
            }
          }
        }

        .text {
          font-size: 18px;
          font-weight: bold;

          &.profit {
            width: 205px;

            span {
              color: #ff0000;

              &.sp {
                color: #26a374;
              }
            }
          }
        }
      }
    }
  }

  .pagination_box {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>